import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, onUnmounted, toRefs, nextTick } from "@nuxtjs/composition-api";
import CloudflareTurnstile from "~/core/components/flows/signin/steps/CloudflareTurnstile.vue";

interface Props {
    isSigningUpLoading?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SignUpAcceptTerms',
  props: {
    isSigningUpLoading: { type: Boolean, default: false }
  },
  emits: ['onContinue'],
  setup(__props: any, { expose, emit: $emit }) {

const props = __props as { isSigningUpLoading: boolean };





const { isSigningUpLoading } = toRefs(props);

const signUpAcceptTerms = ref<HTMLDivElement | null>(null);
const popupComponent = ref(null);
const turnstileResponse = ref('');
const notUSCitizen = ref(false);
const notUAECitizen = ref(false);
const cfTurnstile = ref(null);

const handleRegister = () => {
    if (!notUSCitizen.value || !notUAECitizen.value || !turnstileResponse.value) return;

    $emit('onContinue', { turnstile_response: turnstileResponse.value });
}

const resetTurnstile = async () => {
    cfTurnstile.value?.reset();
    turnstileResponse.value = '';
    const newToken = await waitForCloudFlareTurnstile();
    turnstileResponse.value = newToken;
    return newToken;
}

const waitForCloudFlareTurnstile = () => {
    return new Promise((resolve) => {
        cfTurnstile.value.$on('verify', (token) => {
            resolve(token);
        });
    });
}

const handleResize = () => {
    if (signUpAcceptTerms.value) {
        const firstChild = signUpAcceptTerms.value.children[0] as HTMLElement;
        if (firstChild) {
            firstChild.style.height = '0';
        }
    }
    handleSetScrollHeight();
};

const handleSetScrollHeight = () => {
    if (signUpAcceptTerms.value) {
        const parentHeight = signUpAcceptTerms.value.offsetHeight;
        const firstChild = signUpAcceptTerms.value.children[0] as HTMLElement;
        const secondChild = signUpAcceptTerms.value.children[1] as HTMLElement;

        if (firstChild && secondChild) {
            const secondChildHeight = secondChild.offsetHeight;
            firstChild.style.height = `${parentHeight - secondChildHeight}px`;
        }
    }
}

onMounted(async () => {
    await nextTick();
    window.addEventListener('resize', handleResize);
    popupComponent.value = document.querySelector(".fullscreen-affility-popup");
    popupComponent.value?.classList.add('is-terms-sign-up');
    handleSetScrollHeight();
})

onUnmounted(() => {
    window.removeEventListener('resize', handleResize);
    popupComponent.value?.classList.remove('is-terms-sign-up');
})

expose({
    resetTurnstile,
});

return { __sfc: true,$emit, props, isSigningUpLoading, signUpAcceptTerms, popupComponent, turnstileResponse, notUSCitizen, notUAECitizen, cfTurnstile, handleRegister, resetTurnstile, waitForCloudFlareTurnstile, handleResize, handleSetScrollHeight, CloudflareTurnstile }
}

})